import { useTheme } from "../../contexts/ThemeContext";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const theme = useTheme();
  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) {
      start = Math.max(1, end - maxVisible + 1);
    }
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };

  const btnBase = {
    minWidth: 36,
    height: 36,
    border: "1px solid #d1d5db",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: 14,
    fontFamily: "inherit",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s",
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 6,
        padding: "24px 0 12px",
      }}
    >
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        style={{
          ...btnBase,
          backgroundColor: currentPage === 1 ? "#f3f4f6" : "#fff",
          color: currentPage === 1 ? "#9ca3af" : "#374151",
          cursor: currentPage === 1 ? "not-allowed" : "pointer",
        }}
        aria-label="Página anterior"
      >
        ‹
      </button>
      {getPageNumbers()[0] > 1 && (
        <>
          <button
            onClick={() => onPageChange(1)}
            style={{ ...btnBase, backgroundColor: "#fff", color: "#374151" }}
          >
            1
          </button>
          {getPageNumbers()[0] > 2 && (
            <span style={{ padding: "0 4px", color: "#9ca3af" }}>…</span>
          )}
        </>
      )}
      {getPageNumbers().map((page) => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          style={{
            ...btnBase,
            backgroundColor: page === currentPage ? theme.colors.backgroundColorCardBtn : "#fff",
            color: page === currentPage ? "#fff" : "#374151",
            fontWeight: page === currentPage ? 600 : 400,
            borderColor: page === currentPage ? theme.colors.borderColorCardBtn : "#d1d5db",
          }}
        >
          {page}
        </button>
      ))}
      {getPageNumbers()[getPageNumbers().length - 1] < totalPages && (
        <>
          {getPageNumbers()[getPageNumbers().length - 1] < totalPages - 1 && (
            <span style={{ padding: "0 4px", color: "#9ca3af" }}>…</span>
          )}
          <button
            onClick={() => onPageChange(totalPages)}
            style={{ ...btnBase, backgroundColor: "#fff", color: "#374151" }}
          >
            {totalPages}
          </button>
        </>
      )}
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        style={{
          ...btnBase,
          backgroundColor: currentPage === totalPages ? "#f3f4f6" : "#fff",
          color: currentPage === totalPages ? "#9ca3af" : "#374151",
          cursor: currentPage === totalPages ? "not-allowed" : "pointer",
        }}
        aria-label="Página siguiente"
      >
        ›
      </button>
    </div>
  );
};

export default Pagination;